/**
 * Created by Akihiro-Kato on 2016/06/08.
 */
import React, {Component} from "react";
import {browserHistory, Router, Route, IndexRoute, Link} from 'react-router';
import $ from 'jquery';

export default class Header extends Component {
	constructor(props) {
		super(props);
		this.state = { }
	}

	componentDidMount() {
	}

	render() {
		return (
				<header className="header">
					<div className="inner">
						<div className="logo">
              <h1>
                <Link to="/">
                  <img src="/images/logo.png" alt="GIDS"/>
                  <span>GIFU INDIE<br />DESIGN SESSIONS</span>
                </Link>
              </h1>
            </div>
            <div id="sns">
              <ul>
                <li><a className="facebook" href="https://www.facebook.com/GIDS.GIDS.GIDS/" target="_blank"></a></li>
                <li><a className="instagram" href="https://www.instagram.com/explore/locations/1765771783710793/gids-gifu-indie-design-sessions/" target="_blank"></a></li>
                {/*<li><a href="https://www.facebook.com/sharer/sharer.php?u=" target="_blank"></a></li>*/}
                {/*<li><a href="https://twitter.com/intent/tweet?url=" target="_blank"></a></li>*/}
              </ul>
            </div>
					</div>
				</header>
		)
	}
}


// WEBPACK FOOTER //
// ./src/js/components/_header.js